import { requestConferences } from "../../actions/passcodeManager";

class PasscodeHandler {
  constructor(store) {
    this.store = store;
  }

  requestConferences(filter) {
    this.store.dispatch(requestConferences(filter));
  }
}

export default PasscodeHandler;
